// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9119) return "static/chunks/9119-840adee582a2c367.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"ec2cf5a2938e26c3","2937":"0a588ce09fb27a14"}[chunkId] + ".js";
};